import React from 'react'
import Loadable from 'react-loadable'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

class LoadingPage extends React.Component {
  //类似github页面上面加载的那个加载条
  componentWillMount(){
    NProgress.start()
  }
  componentWillUnmount(){
    NProgress.done()
  }
  render () {
    return (
      <div/>
    )
  }
}

// <!--异步加载 路由懒加载 -->
const LoadableComponent = (component) => {
  return Loadable({
    loader: () => component().then((module) => module.default || module),
    loading: ()=><LoadingPage/>
  })
}

export default LoadableComponent
